/**
 *
 * AppBar Layout
 *
 */

import React from "react";
import classnames from "classnames";
import { stylize, ProgressBar } from "@envestnet/envreact-component-library";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-regular-svg-icons";
import styles, { Styles } from "./styles";

type Props = Styles & {
  isLoading?: boolean;
  appBarTheme?: { background: string; text: string };
  brandLogoImage?: string;
  firmName?: string;
  className?: string;
  style?: React.CSSProperties;
  renderTitle?: Function;
  showCloseButton?: boolean;
  // Callback triggered when close button is pressed
  onClose?: () => void;
};

function AppBar(props: Props) {
  const {
    className,
    classes,
    isLoading,
    showCloseButton = false,
    appBarTheme,
    brandLogoImage,
    firmName,
    renderTitle,
    onClose,
    style,
  } = props;

  const fitTextStyle = {
    fontWeight: 900,
  };

  return (
    <header
      className={classnames(classes.container, className, {
        "custom-text": !!appBarTheme?.text,
        "custom-background": !!appBarTheme?.background,
      })}
      role="banner"
      style={style}
    >
      <div className={classes.logoContainer}>
        {brandLogoImage ? (
          <img src={brandLogoImage} className={classes.logo} alt="logo" />
        ) : (
          <div
            className={classes.firmAsLogo}
            style={{
              ...fitTextStyle,
            }}
          >
            <span>{firmName ? firmName.toUpperCase() : " "}</span>
          </div>
        )}
      </div>

      <div className={classes.main}>
        <div className={classes.titleContainer}>
          {renderTitle && renderTitle()}
        </div>
        <div className={classes.infoContainer}>
          {showCloseButton && (
            <div>
              <FontAwesomeIcon
                aria-label="close"
                icon={faTimes}
                onClick={onClose}
                className={classes.closeButton}
              />
            </div>
          )}
        </div>
      </div>
      {isLoading && <ProgressBar className={classes.loadingIndicator} />}
    </header>
  );
}

export default stylize<Props>(styles)(AppBar);
